import React from 'react';
import PropTypes from 'prop-types';
import { Radio as RadioButton } from 'react-bootstrap';
import moment from 'moment';
import StringConstant from '../../constants/StringConstants';
import DateUtils from '../../utils/DateUtils';
import DateTimeField from '../bootstrap-datetimepicker';
import _ from 'lodash';
import StringConstants from '../../constants/StringConstants';
import FrequencyUtils from '../../utils/FrequencyUtils';
import RegexUtils from '../../utils/RegexUtils';
import ValidationConfig from '../../config/ValidationConfig';
import config from '../../config';
import MoveMoneyBL from './MoveMoneyBL';
import { MenuItem } from 'react-bootstrap';
import { Dropdown } from 'react-bootstrap';
import MoveMoneyPayeeStore from '../../stores/MoveMoneyPayeeStore';
import MoveMoneyPayeeActionCreator from '../../actions/MoveMoneyPayeeActionCreator';
import { Icon } from 'web-ui-components/lib/atoms/iconography';

import { Loader } from 'web-ui-components/lib/organisms/modals';
import { NavigationButton } from 'web-ui-components/lib/navigation/buttons';
import MoveMoneyApiUtils from '../../utils/MoveMoneyApiUtils';
import { AbusiveReferenceModal } from './AbusiveReferenceModal';
import UserManagementStore from '../../stores/UserManagementStore';

class RepeatPayment extends React.Component {
  constructor(props) {
    super(props);
    this.howOftenChange = this.howOftenChange.bind(this);
    this.setOneOffData = this.setOneOffData.bind(this);
    this.onStopItWhenChange = this.onStopItWhenChange.bind(this);
    this.renderFormField = this.renderFormField.bind(this);
    this.renderReference = this.renderReference.bind(this);
    this.renderPaymentType = this.renderPaymentType.bind(this);
    this.setWhenDate = this.setWhenDate.bind(this);
    this.getFormData = this.getFormData.bind(this);
    this.setReccuringData = this.setReccuringData.bind(this);
    this.renderWhen = this.renderWhen.bind(this);
    this.onWhenChange = this.onWhenChange.bind(this);
    this.onStartChange = this.onStartChange.bind(this);
    this.endDateChange = this.endDateChange.bind(this);
    this.onNumberOfPaymentChange = this.onNumberOfPaymentChange.bind(this);
    this.onNumberOfPaymentBlur = this.onNumberOfPaymentBlur.bind(this);
    this.onPaymentTypeChange = this.onPaymentTypeChange.bind(this);
    this.onRefChange = this.onRefChange.bind(this);
    this.onWhenBlur = this.onWhenBlur.bind(this);
    this.onWhenFocus = this.onWhenFocus.bind(this);
    this.onStartDateFocus = this.onStartDateFocus.bind(this);
    this.onStartDateBlur = this.onStartDateBlur.bind(this);
    this.onEndDateFocus = this.onEndDateFocus.bind(this);
    this.onEndDateBlur = this.onEndDateBlur.bind(this);
    this.continueClick = this.continueClick.bind(this);
    this.onRefBlur = this.onRefBlur.bind(this);
    this.resetRepeatOneOffData = this.resetRepeatOneOffData.bind(this);
    this.updateFeildValid = this.updateFieldValid.bind(this);
    this.onStoreChange = this.onStoreChange.bind(this);
    const maxDate = moment().add(1, 'years');
    const minDate = moment().add(1, 'days');
    this.state = {
      showHowMany: false,
      showEndDate: false,
      stopWhenSelectedOption: '1',
      selectedHowOften: StringConstant.pleaseSelect,
      startMaxDate: maxDate,
      startDateValue: moment(minDate, config.dateFormatSlash).format(
        config.dateFormatTimeline
      ),
      endDateValue: moment(minDate, config.dateFormatSlash).format(
        config.dateFormatTimeline
      ),
      endMinDate: minDate,
      startMinDate: minDate,
      continueClick: false,
      maxDate,
      reference: this.props.repeatPaymentOptions.referenceData,
      oneOffPayment: true,
      dateInputFormat: config.dateFormatSlash,
      startDateInputFormat: config.dateFormatTimeline,
      endDateInputFormat: config.dateFormatTimeline,
      fieldBlur: {
        reference: false,
        startDate: false,
        noOfTimes: false,
        whenBlur: false,
        endDate: false,
      },
      fieldValid: {},
      repeatFieldValid: {
        startDate: true,
        howOften: false,
      },

      startDateText: null,
      endDateText: null,
      selectedPayee: this.props.selectedPayee,
      showGlobalLoader: false,
      showButtonLoader: false,
      showAbusiveReferenceModal: false,
      isAbusiveReferenceCheckRequired: true,
    };
  }
  componentWillMount() {
    this.isComponentMounted = true;

    // Set When Date
    const repeatData = this.props.repeatData;
    this.state.oneOffPayment = repeatData.oneOffPayment;
    if (repeatData.oneOffPayment) {
      this.setOneOffData(repeatData);
    } else {
      if (repeatData.howOften && repeatData.startDate && repeatData.stopWhen) {
        this.setReccuringData(repeatData);
      } else {
        this.setState({
          oneOffPayment: repeatData.oneOffPayment,
        });
      }
    }

    if (this.props.repeatPaymentOptions.isReference) {
      if (
        repeatData.reference !== null &&
        repeatData.reference === this.props.originalReference
      ) {
        this.setState({
          reference: repeatData.reference,
        });
      }
    }
    MoveMoneyPayeeStore.addChangeListener(this.onStoreChange);
  }

  componentWillUnmount() {
    this.isComponentMounted = false;

    MoveMoneyPayeeStore.removeChangeListener(this.onStoreChange);
  }

  onStoreChange() {
    const srdResponse = MoveMoneyPayeeStore.getCopCheckNeeded();
    const repeatData = this.getFormData();
    const { originalReference } = this.props;

    if (
      this.state.reference !== originalReference &&
      this.state.continueClick
    ) {
      if (srdResponse === true) {
        this.props.showCopComponent(repeatData);
      } else {
        this.props.continueClick(repeatData);
      }
    }
  }

  onEndDateBlur() {
    if (this.state.repeatFieldValid.endDate) {
      if (this.state.endDateInputFormat === config.dateFormatSlash) {
        const showEndDate = moment(
          this.state.endDateValue,
          config.dateFormatSlash
        ).format(config.dateFormatTimeline);
        this.setState({
          endDateValue: showEndDate,
          endDateInputFormat: config.dateFormatTimeline,
        });
      }
    }
    this.fieldBlur('endDate');
    this.checkOnBlurFeildValid('endDate');
  }
  onEndDateFocus() {
    if (this.state.repeatFieldValid.endDate) {
      if (this.state.endDateInputFormat === config.dateFormatTimeline) {
        const endDate = moment(
          this.state.endDateValue,
          config.dateFormatTimeline
        ).format(config.dateFormatSlash);
        this.setState({
          endDateValue: endDate,
          endDateInputFormat: config.dateFormatSlash,
        });
      }
    }
  }
  onNumberOfPaymentBlur(e) {
    const name = e.target.name;
    this.fieldBlur(name);
    this.checkOnBlurFeildValid(name);
  }
  onNumberOfPaymentChange(e) {
    e.preventDefault();
    const name = e.target.name;
    const value = e.target.value;
    const validationResult = ValidationConfig.validateData(name, value);
    // If validation criteria is matched
    if (validationResult.isValid) {
      if (parseFloat(value) === 0.0) {
        this.setState({
          howMany: e.target.value,
        });
        this.updateFieldValid(name, false);
        this.setState({
          showhowManyEdgeMessage: false,
        });
        // this.showError(name, true);
      } else if (value <= StringConstants.noOfTimesLimit) {
        this.updateFieldValid(name, true);
      } else {
        this.updateFieldValid(name, false);
        if (!this.state.showhowManyEdgeMessage) {
          this.setState({
            showhowManyEdgeMessage: true,
          });
        }
      }
      this.setState({
        howMany: e.target.value,
      });
    } else {
      if (value.length === 0) {
        this.setState({
          howMany: e.target.value,
        });
        this.updateFieldValid(name, false);
        this.setState({
          showhowManyEdgeMessage: false,
        });
      }
    }
  }
  onPaymentTypeChange(e) {
    switch (e.target.value) {
      case '1':
        this.setState({
          oneOffPayment: true,
        });
        break;
      case '2':
        const formatDate = moment(this.state.startDateValue).format(
          'DD/MM/YYYY'
        );
        const day = MoveMoneyBL.getRepeatPaymentDay(formatDate);
        this.setState({
          oneOffPayment: false,
          startDateText: day,
          endDateText: day,
        });
        break;
    }
    this.resetRepeatOneOffData();
  }
  onRefBlur(e) {
    const name = e.target.name;
    if (!this.props.repeatPaymentOptions.isTransfer) {
      this.fieldBlur(name);
      this.checkOnBlurFeildValid(name);
    }
    this.setState({
      reference: e.target.value.trim(),
    });
  }
  onRefChange(e) {
    const name = e.target.name;
    const value = e.target.value;
    const expression = RegexUtils.regexes.referenceRegex;
    const actualValue = value.match(expression)[0];
    if (!this.props.repeatPaymentOptions.isTransfer) {
      if (actualValue.trim().length === 0) {
        this.updateFieldValid(name, false);
      } else {
        this.updateFieldValid(name, true);
      }
    }

    this.setState((prevState) => ({
      reference: actualValue,
      // User corrects the abusiveReference override - trigger another check
      ...(!prevState.isAbusiveReferenceCheckRequired && {
        isAbusiveReferenceCheckRequired: true,
      }),
    }));
  }
  onStartChange(e) {
    if (e !== 'Invalid date') {
      this.setState({ startDateValue: e });
      this.state.startDateValue = e;
      if (this.state.startDateInputFormat === config.dateFormatTimeline) {
        this.setState({ startDateInputFormat: config.dateFormatTimeline });
        e = moment(e, config.dateFormatTimeline).format(config.dateFormatSlash);
      }
      const validationResult = ValidationConfig.validateDate(e);
      let dateDifference = 0;
      if (!validationResult) {
        this.updateFieldValid('startDate', false);
      } else {
        let dateIsLessThan = true;
        dateIsLessThan = ValidationConfig.isBefore(e, moment().add(1, 'years'));
        const isGretaterThanCurrentDate = ValidationConfig.isAfter(e, moment());
        if (dateIsLessThan && isGretaterThanCurrentDate) {
          this.updateFieldValid('startDate', true);
          dateDifference = DateUtils.comapareFromCurrentDateSlashFormat(e);
          this.state.endDateInputFormat = config.dateFormatTimeline;
          if (this.state.stopWhenSelectedOption === '3') {
            this.endDateChange(
              moment(e, config.dateFormatSlash).format(
                config.dateFormatTimeline
              )
            );
          }
          this.setState({
            startDateText: MoveMoneyBL.getRepeatPaymentDay(e),
          });
        } else {
          this.updateFieldValid('startDate', false);
        }
      }
      this.setState({
        endMinDate: moment().add(dateDifference, StringConstants.Days),
      });
    } else {
      this.updateFieldValid('startDate', false);
      this.setState({
        startDateInputFormat: config.dateFormatSlash,
      });
    }
  }
  onStartDateBlur() {
    if (this.state.repeatFieldValid.startDate) {
      if (this.state.startDateInputFormat === config.dateFormatSlash) {
        const showStartDate = moment(
          this.state.startDateValue,
          config.dateFormatSlash
        ).format(config.dateFormatTimeline);
        this.setState({
          startDateValue: showStartDate,
          startDateInputFormat: config.dateFormatTimeline,
        });
      }
    }
    this.fieldBlur('startDate');
    this.checkOnBlurFeildValid('startDate');
  }

  onStartDateFocus() {
    if (this.state.repeatFieldValid.startDate) {
      if (this.state.startDateInputFormat === config.dateFormatTimeline) {
        const startDate = moment(
          this.state.startDateValue,
          config.dateFormatTimeline
        ).format(config.dateFormatSlash);
        this.setState({
          startDateValue: startDate,
          startDateInputFormat: config.dateFormatSlash,
        });
      }
    }
  }
  onStopItWhenChange(e) {
    const value = e.target.value;
    const maxDate = moment().add(1, 'years');
    switch (value) {
      case '1':
        this.setState({
          renderEndDate: false,
          showHowMany: false,
          showEndDate: false,
          startMaxDate: maxDate,
          endDateValue: this.state.startDateValue,
        });
        delete this.state.repeatFieldValid['noOfTimes'];
        delete this.state.repeatFieldValid['endDate'];
        break;
      case '2':
        this.setState({
          showEndDate: false,
          showHowMany: true,
          howMany: '',
          startMaxDate: maxDate,
          endDateValue: this.state.startDateValue,
        });
        this.state.repeatFieldValid.noOfTimes = false;
        delete this.state.repeatFieldValid['endDate'];
        break;
      case '3':
        this.setState({
          showEndDate: true,
          showHowMany: false,
          endDateValue: this.state.startDateValue,
        });
        this.state.repeatFieldValid.endDate = true;
        delete this.state.repeatFieldValid['noOfTimes'];
        break;
    }
    this.setState({
      stopWhenSelectedOption: value,
    });
  }
  onWhenBlur() {
    if (this.state.fieldValid.futureDate) {
      if (this.state.dateInputFormat === config.dateFormatSlash) {
        const showWhenDate = moment(
          this.state.defaultValue,
          config.dateFormatSlash
        ).format(config.dateFormatTimeline);
        this.setState({
          defaultValue: showWhenDate,
          dateInputFormat: config.dateFormatTimeline,
        });
      }
    }
    this.fieldBlur('futureDate');
    this.checkOnBlurFeildValid('futureDate');
  }
  // Checks the when Date
  onWhenChange(e) {
    if (e !== 'Invalid date') {
      this.setState({ defaultValue: e });
      if (this.state.dateInputFormat === config.dateFormatTimeline) {
        // why?
        this.setState({ dateInputFormat: config.dateFormatTimeline });
        e = moment(e, config.dateFormatTimeline).format(config.dateFormatSlash);
      }
      const validationResult = ValidationConfig.validateDate(e);
      if (validationResult) {
        const dateIsLessThanOneYearFromNow = ValidationConfig.isBefore(
          e,
          moment().add(1, 'years')
        );
        const yesterday = moment().add(-1, 'day');
        const isGreaterThanCurrentDate = ValidationConfig.isAfter(e, yesterday);
        if (isGreaterThanCurrentDate && dateIsLessThanOneYearFromNow) {
          this.updateFieldValid('futureDate', true);
          this.setState({ whenText: MoveMoneyBL.getRepeatPaymentDay(e) });
        } else {
          this.updateFieldValid('futureDate', false);
        }
      }
    } else {
      this.setState({ whenText: null });
      this.updateFieldValid('futureDate', false);
    }
  }
  onWhenFocus() {
    if (this.state.fieldValid.futureDate) {
      if (this.state.dateInputFormat === config.dateFormatTimeline) {
        const whenDate = moment(
          this.state.defaultValue,
          config.dateFormatTimeline
        ).format(config.dateFormatSlash);
        this.setState({
          defaultValue: whenDate,
          dateInputFormat: config.dateFormatSlash,
        });
      }
    }
  }
  getFormData() {
    const repeatData = {
      reference: this.state.reference,
      oneOffPayment: this.state.oneOffPayment,
    };
    if (this.state.oneOffPayment) {
      if (this.state.defaultValue.indexOf('/') < 0) {
        this.state.defaultValue = moment(
          this.state.defaultValue,
          config.dateFormatTimeline
        ).format(config.dateFormatSlash);
      }
      repeatData.futureDate = this.state.defaultValue;
    } else {
      if (this.state.startDateValue.indexOf('/') < 0) {
        this.state.startDateValue = moment(
          this.state.startDateValue,
          config.dateFormatTimeline
        ).format(config.dateFormatSlash);
      }
      repeatData.howOften = this.state.howOftenKey;
      repeatData.startDate = this.state.startDateValue;
      repeatData.stopWhen = this.state.stopWhenSelectedOption;
      switch (this.state.stopWhenSelectedOption) {
        case '2':
          repeatData.endValue = this.state.howMany;
          break;
        case '3':
          if (this.state.endDateValue.indexOf('/') < 0) {
            this.state.endDateValue = moment(
              this.state.endDateValue,
              config.dateFormatTimeline
            ).format(config.dateFormatSlash);
          }
          repeatData.endValue = this.state.endDateValue;
          break;
      }
    }
    return repeatData;
  }
  setInputFocus(field) {
    if (
      field === 'futureDate' ||
      field === 'endDate' ||
      field === 'startDate'
    ) {
      this.refs[field].refs[`${field}Input`].focus();
    } else if (this.refs[field]) {
      this.refs[field].focus();
    }
  }
  setOneOffData(repeatData) {
    this.setWhenDate(repeatData.futureDate);
  }
  setReccuringData(repeatData) {
    this.state.howOftenKey = repeatData.howOften;
    const selectedHowOften = FrequencyUtils.getFrequencyValue(
      repeatData.howOften
    );
    const stopWhenSelectedOption = repeatData.stopWhen;
    this.updateFieldValid('howOften', true);
    if (repeatData.startDate !== StringConstant.chooseDate) {
      const endDate = moment(
        repeatData.startDate,
        config.dateFormatSlash
      ).format(config.dateFormatTimeline);
      this.setState({
        startDateValue: endDate,
        startDateText: MoveMoneyBL.getRepeatPaymentDay(endDate),
      });
      this.updateFieldValid('startDate', true);
    } else {
      this.updateFieldValid('startDate', false);
    }
    switch (stopWhenSelectedOption) {
      case '2':
        this.setState({
          showHowMany: true,
          howMany: repeatData.endValue,
        });
        this.updateFieldValid('howMany', true);
        break;
      case '3':
        if (repeatData.endValue !== StringConstant.chooseDate) {
          const endDate = moment(
            repeatData.endValue,
            config.dateFormatSlash
          ).format(config.dateFormatTimeline);
          this.setState({
            showEndDate: true,
            endDateValue: endDate,
            defaultEndValue: endDate,
          });
          this.updateFieldValid('endDate', true);
        } else {
          this.updateFieldValid('endDate', false);
        }

        break;
    }
    this.setState({
      selectedHowOften,
      stopWhenSelectedOption,
      oneOffPayment: repeatData.oneOffPayment,
    });
  }
  setWhenDate(whenDate) {
    if (this.state.dateInputFormat === config.dateFormatSlash) {
      this.setState({ whenText: MoveMoneyBL.getRepeatPaymentDay(whenDate) });
      whenDate = moment(whenDate, config.dateFormatSlash).format(
        config.dateFormatTimeline
      );
      this.setState({
        defaultValue: whenDate,
        dateInputFormat: config.dateFormatTimeline,
      });
    }
    this.state.fieldValid.futureDate = true;
  }

  checkFormValid() {
    let isGroupValid = true;
    let focusField = false;
    const formFieldsValid = this.state.oneOffPayment
      ? this.state.fieldValid
      : this.state.repeatFieldValid;
    const formFields = Object.keys(formFieldsValid);
    if (formFields.length !== 0) {
      _.every(formFields, (formField) => {
        if (!formFieldsValid[formField]) {
          this.refs[`${formField}Component`].classList.toggle(
            'c-field--error',
            true
          );
          isGroupValid = false;
          if (!focusField) {
            this.setInputFocus(formField);
            focusField = true;
          }
        }
        return true;
      });
    }
    if (
      this.state.selectedHowOften === StringConstant.pleaseSelect &&
      !this.state.oneOffPayment
    ) {
      isGroupValid = false;
      this.showError('howOften', true);
    }

    return isGroupValid;
  }
  checkOnBlurFeildValid(name) {
    const field = this.state.oneOffPayment
      ? this.state.fieldValid
      : this.state.repeatFieldValid;
    if (field.hasOwnProperty(name) && field[name] === false) {
      this.showError(name, true);
    }
  }

  async continueClick() {
    const {
      selectedPayee,
      originalReference,
      repeatPaymentOptions: { isReference: hasReferenceField } = {},
      fromSelectedAccount,
    } = this.props;

    const { isAbusiveReferenceCheckRequired } = this.state;

    this.setState({
      continueClick: true,
    });

    if (this.checkFormValid()) {
      const isExternalPayee = !!selectedPayee.id;
      const repeatData = this.getFormData();

      // pure retail users only - no Business in RiB or BiB
      if (
        !UserManagementStore.isBusinessUser() &&
        hasReferenceField &&
        isExternalPayee &&
        isAbusiveReferenceCheckRequired
      ) {
        this.setState({ showButtonLoader: true });

        const {
          to_account: {
            account_number: payeeAccountNumber,
            sort_code: payeeSortCode,
          },
        } = selectedPayee;
        const {
          accountNumber: payerAccountNumber,
          sortCode: payerSortCode,
          accountName: payerAccountName,
        } = fromSelectedAccount;

        const isAbusiveReference = await MoveMoneyApiUtils.isAbusiveReference({
          paymentReference: this.state.reference,
          payerAccountNumber,
          payerSortCode,
          payeeAccountNumber,
          payeeSortCode,
        });

        // Edge case
        if (!this.isComponentMounted) {
          return;
        }

        this.setState({ showButtonLoader: false });

        if (isAbusiveReference) {
          const [replacementWord = ''] = payerAccountName.match(
            RegexUtils.regexes.referenceRegex
          );

          this.setState({
            showAbusiveReferenceModal: true,
            isAbusiveReferenceCheckRequired: false,
            reference: replacementWord,
          });

          return;
        }
      }

      if (this.state.reference !== originalReference && isExternalPayee) {
        this.setState({ showGlobalLoader: true });
        MoveMoneyPayeeActionCreator.verifySRDPayee(
          `${selectedPayee.to_account.sort_code}${selectedPayee.to_account.account_number}`
        );
        this.props.setupStore(this.state.reference, repeatData);
      } else {
        this.props.continueClick(repeatData);
      }
    }
  }
  endDateChange(e) {
    if (e !== 'Invalid date') {
      this.setState({ endDateValue: e });
      if (this.state.endDateInputFormat === config.dateFormatTimeline) {
        this.setState({ endDateInputFormat: config.dateFormatTimeline });
        e = moment(e, config.dateFormatTimeline).format(config.dateFormatSlash);
      }
      const validationResult = ValidationConfig.validateDate(e);
      if (validationResult) {
        let isGretaterThanCurrentDate = true;
        const dateIsLessThan = ValidationConfig.isBefore(
          e,
          moment().add(1, 'years')
        );
        if (this.state.repeatFieldValid['startDate']) {
          let startDate = this.state.startDateValue;
          if (this.state.startDateInputFormat === config.dateFormatTimeline) {
            startDate = moment(
              this.state.startDateValue,
              config.dateFormatTimeline
            )
              .add(-1, 'days')
              .format(config.dateFormatSlash);
          }
          isGretaterThanCurrentDate = ValidationConfig.isAfter(e, startDate);
        } else {
          isGretaterThanCurrentDate = ValidationConfig.isAfter(e, moment());
        }
        if (isGretaterThanCurrentDate && dateIsLessThan) {
          this.setState({
            endDateText: MoveMoneyBL.getRepeatPaymentDay(e),
          });
          this.updateFieldValid('endDate', true);
        } else {
          this.updateFieldValid('endDate', false);
        }
      } else {
        this.updateFieldValid('endDate', false);
      }
    } else {
      this.updateFieldValid('endDate', false);
      this.setState({ endDateText: null });
      this.setState({
        endDateInputFormat: config.dateFormatSlash,
      });
    }
  }
  fieldBlur(fieldName) {
    this.state.fieldBlur[fieldName] = true;
  }
  howOftenChange(e) {
    const selectedHowOften = FrequencyUtils.getFrequencyValue(e);
    this.state.howOftenKey = e;
    this.setState({
      selectedHowOften,
    });
    this.state.fieldBlur.howOften = true;
    this.showError('howOften', false);
    // add Field is Valid
    this.state.repeatFieldValid.howOften = true;
  }
  resetRepeatOneOffData() {
    const maxDate = moment().add(1, 'years');
    const minDate = moment().add(1, 'days');
    this.setState({
      showHowMany: false,
      showEndDate: false,
      stopWhenSelectedOption: '1',
      selectedHowOften: StringConstant.pleaseSelect,
      startMaxDate: maxDate,
      startDateValue: moment(minDate, config.dateFormatSlash).format(
        config.dateFormatTimeline
      ),
      endDateValue: moment(minDate, config.dateFormatSlash).format(
        config.dateFormatTimeline
      ),
      endMinDate: minDate,
      startMinDate: minDate,
      dateInputFormat: config.dateFormatTimeline,
      startDateInputFormat: config.dateFormatTimeline,
      defaultValue: moment().format(config.dateFormatTimeline),
      endDateInputFormat: config.dateFormatTimeline,
    });
    this.state.repeatFieldValid.startDate = true;
    this.state.repeatFieldValid.howOften = false;
    this.state.fieldValid.futureDate = true;
    delete this.state.repeatFieldValid['noOfTimes'];
    delete this.state.repeatFieldValid['endDate'];
  }
  showError(name, show) {
    if (this.refs[`${name}Component`] && this.state.fieldBlur[name]) {
      if (show) {
        this.refs[`${name}Component`].classList.add('c-field--error');
      } else {
        this.refs[`${name}Component`].classList.remove('c-field--error');
      }
    }
  }
  showNumberOfTimes() {
    const howManyComponent = (
      <div className="c-field" ref="noOfTimesComponent">
        <label
          id="numberOfTimes"
          className="c-field__label c-field__label--block"
          htmlFor="f1"
        >
          {this.props.content.howManyTimes}
        </label>
        <div className="c-field__controls">
          <input
            className="c-field__input"
            aria-labelledby="numberOfTimes"
            aria-invalid="false"
            type="text"
            name="noOfTimes"
            ref="howMany"
            id="f1"
            value={this.state.howMany}
            onChange={this.onNumberOfPaymentChange}
            onBlur={this.onNumberOfPaymentBlur}
            placeholder=" "
            autoComplete="off"
          />
          <div
            className="c-field__message"
            id="noOfTimesAria"
            role="alert"
            ref="howManyMessage"
          >
            <p>
              {this.state.showhowManyEdgeMessage
                ? this.props.content.noOfTimesEdgeCaseMessage
                : this.props.content.noOfTimesMsg}
            </p>
          </div>
        </div>
      </div>
    );
    return this.state.showHowMany ? howManyComponent : null;
  }
  showOneOffPayment() {
    return (
      <div className="c-field c-field--datepicker" ref="futureDateComponent">
        <label
          className="c-field__label c-field__label--block"
          htmlFor="dtWhen"
        >
          {this.props.content.when}
          <div className="c-field__instructions">
            {this.props.content.datePickerText}
          </div>
        </label>
        <div className="c-field__controls">
          <div className="c-field__append">
            <div className="pos-r">{this.renderWhen()}</div>
            {this.state.whenText && (
              <div className="callout callout--pointer callout--pointer-left">
                <div className="callout__wrapper">
                  <p>{this.state.whenText}</p>
                </div>
              </div>
            )}
          </div>
          <div className="c-field__message" id="whenMsgErr" role="alert">
            <p>{this.props.content.dateErrorMesaage}</p>
          </div>
        </div>
      </div>
    );
  }
  showRepeatPayment() {
    return (
      <div>
        <div
          className="c-field payment-type__frequency--repeat"
          ref="howOftenComponent"
        >
          <label
            id="repeatPayment"
            className="c-field__label c-field__label--block"
            htmlFor="dropdown-custom-menu"
          >
            {this.props.content.howOften}
          </label>
          <div className="c-field__controls">
            <div className="btn-toolbar">
              <Dropdown
                id="dropdown-custom-menu"
                name="dropdown-custom-menu"
                className="custom-dropdown"
              >
                <Dropdown.Toggle
                  noCaret
                  aria-labelledby="repeatPayment selectedValue"
                >
                  <span id="selectedValue" className="btn--title">
                    {this.state.selectedHowOften}
                  </span>
                  <span className="symbol">
                    <Icon iconType="ChevronDownSolidSmall" size="sm" />
                  </span>
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <MenuItem eventKey="1 weekly" onSelect={this.howOftenChange}>
                    {this.props.content.Weekly}
                  </MenuItem>
                  <MenuItem eventKey="2 weekly" onSelect={this.howOftenChange}>
                    {this.props.content.twoWeekly}
                  </MenuItem>
                  <MenuItem eventKey="3 weekly" onSelect={this.howOftenChange}>
                    {this.props.content.threeWeekly}
                  </MenuItem>
                  <MenuItem eventKey="4 weekly" onSelect={this.howOftenChange}>
                    {this.props.content.fourWeekly}
                  </MenuItem>
                  <MenuItem eventKey="1 monthly" onSelect={this.howOftenChange}>
                    {this.props.content.monthly}
                  </MenuItem>
                  <MenuItem eventKey="2 monthly" onSelect={this.howOftenChange}>
                    {this.props.content.twoMonthly}
                  </MenuItem>
                  <MenuItem eventKey="3 monthly" onSelect={this.howOftenChange}>
                    {this.props.content.threeMonthly}
                  </MenuItem>
                  <MenuItem eventKey="6 monthly" onSelect={this.howOftenChange}>
                    {this.props.content.sixMonthly}
                  </MenuItem>
                  <MenuItem
                    eventKey="12 monthly"
                    onSelect={this.howOftenChange}
                  >
                    {this.props.content.anually}
                  </MenuItem>
                </Dropdown.Menu>
              </Dropdown>
            </div>
            <div className="c-field__message">
              <p>{this.props.content.howOftenErrorMessage}</p>
            </div>
          </div>
        </div>
        {this.renderStartDate()}
        <div className="c-field payment-type__frequency__stop">
          <label
            className="c-field__label c-field__label--block"
            htmlFor="radio_button_D3"
          >
            <span id="frequency_stop">{this.props.content.stopitWhen}</span>
          </label>
          <div className="c-field__controls">
            <div className="c-radio" DefaultValue="1">
              <RadioButton
                aria-labelledby="frequency_stop frequency_stop_type1"
                id="radio_button_D3"
                name="stopFrequency"
                value="1"
                className="c-radio__inline"
                checked={this.state.stopWhenSelectedOption === '1'}
                onClick={this.onStopItWhenChange}
                inline
              >
                <label
                  id="frequency_stop_type1"
                  htmlFor="radio_button_D3"
                  className="c-radio__label c-radio__label--border"
                >
                  {this.props.content.whenIcancel}
                </label>
              </RadioButton>

              <RadioButton
                aria-labelledby="frequency_stop frequency_stop_type2"
                id="radio_button_D4"
                name="stopFrequency"
                value="2"
                className="c-radio__inline"
                checked={this.state.stopWhenSelectedOption === '2'}
                onClick={this.onStopItWhenChange}
                inline
              >
                <label
                  id="frequency_stop_type2"
                  htmlFor="radio_button_D4"
                  className="c-radio__label c-radio__label--border"
                >
                  {this.props.content.noOfTimes}
                </label>
              </RadioButton>

              <RadioButton
                aria-labelledby="frequency_stop frequency_stop_type3"
                id="radio_button_D5"
                name="stopFrequency"
                value="3"
                className="c-radio__inline"
                checked={this.state.stopWhenSelectedOption === '3'}
                onClick={this.onStopItWhenChange}
                inline
              >
                <label
                  id="frequency_stop_type3"
                  htmlFor="radio_button_D5"
                  className="c-radio__label c-radio__label--border"
                >
                  {this.props.content.pickdate}
                </label>
              </RadioButton>
            </div>
          </div>
        </div>
        {this.renderEndDate()}
        {this.showNumberOfTimes()}
      </div>
    );
  }
  updateFieldValid(name, isValid) {
    if (name === 'reference') {
      this.setState((state) => ({
        fieldValid: {
          ...state.fieldValid,
          [name]: isValid,
        },
        repeatFieldValid: {
          ...state.repeatFieldValid,
          [name]: isValid,
        },
      }));
    } else {
      if (this.state.oneOffPayment) {
        this.setState((state) => ({
          fieldValid: {
            ...state.fieldValid,
            [name]: isValid,
          },
        }));
      } else {
        this.setState((state) => ({
          repeatFieldValid: {
            ...state.repeatFieldValid,
            [name]: isValid,
          },
        }));
      }
    }
    this.showError(name, !isValid);
  }
  renderEndDate() {
    const dateInputProps = {
      id: 'dtEnd',
      name: 'dtEnd',
      onBlur: (e) => this.onEndDateBlur(e),
      onFocus: (e) => this.onEndDateFocus(e),
      ref: 'endDateInput',
      'aria-invalid': 'false',
    };
    const endDateComponent = (
      <div className="c-field movemoney__datepicker" ref="endDateComponent">
        <label className="c-field__label c-field__label--block" htmlFor="dtEnd">
          {this.props.content.endDate}
          <div className="c-field__instructions">
            {this.props.content.datePickerText}
          </div>
        </label>
        <div className="c-field__controls">
          <div className="c-field__append">
            <div className="pos-r">
              <DateTimeField
                dateTime={this.state.endDateValue}
                defaultText={this.state.defaultEndValue}
                format={this.state.endDateInputFormat}
                inputFormat={this.state.endDateInputFormat}
                inputProps={dateInputProps}
                maxDate={moment().add(1, 'years')}
                minDate={this.state.endMinDate}
                mode="date"
                onChange={this.endDateChange}
                ref="endDate"
                viewMode="days"
              />
            </div>
            {this.state.endDateText && (
              <div className="callout callout--pointer callout--pointer-left">
                <div className="callout__wrapper">
                  <p>{this.state.endDateText}</p>
                </div>
              </div>
            )}
          </div>
          <div
            className="c-field__message"
            ref="endDateMessage"
            id="endMsgErr"
            role="alert"
          >
            <p>{this.props.content.dateErrorMesaage}</p>
          </div>
        </div>
      </div>
    );
    return this.state.showEndDate ? endDateComponent : null;
  }
  renderFormField() {
    return (
      <div className="form-field">
        {this.renderPaymentType()}
        {this.state.oneOffPayment
          ? this.showOneOffPayment()
          : this.showRepeatPayment()}
      </div>
    );
  }
  renderPaymentType() {
    return (
      <div className="c-field payment-type__frequency">
        <label className="c-field__label c-field__label--block" htmlFor="">
          <span id="frequency_label">{this.props.content.paymentType}</span>
          <div
            id="frequency_desc"
            className="c-field__instructions"
            dangerouslySetInnerHTML={{
              __html: this.props.content.repeatingPaymentText,
            }}
          />
        </label>
        <div className="c-field__controls">
          <div className="c-radio">
            <RadioButton
              id="radio_button_D1"
              aria-labelledby="frequency_label frequency_desc type_oneoff"
              value="1"
              name="radioGroupDefault"
              className="c-radio__inline"
              checked={this.state.oneOffPayment}
              onClick={this.onPaymentTypeChange}
              inline
            >
              <label
                id="type_oneoff"
                htmlFor="radio_button_D1"
                className="c-radio__label c-radio__label--border"
              >
                {this.props.content.oneOffPayment}
              </label>
            </RadioButton>

            <RadioButton
              id="radio_button_D2"
              aria-labelledby="frequency_label frequency_desc type_repeat"
              value="2"
              name="radioGroupDefault"
              className="c-radio__inline"
              checked={!this.state.oneOffPayment}
              onClick={this.onPaymentTypeChange}
              inline
            >
              <label
                id="type_repeat"
                htmlFor="radio_button_D2"
                className="c-radio__label c-radio__label--border"
              >
                {this.props.content.repeatingPayment}
              </label>
            </RadioButton>
          </div>
        </div>
      </div>
    );
  }
  renderReference() {
    let isReadOnly = this.props.repeatPaymentOptions.isNotEditable;
    const className = isReadOnly ? 'c-field c-field--disabled' : 'c-field';

    return (
      <div className={className} ref="referenceComponent">
        <label className="c-field__label c-field__label--block" htmlFor="f1">
          {this.props.content.reference}
          {this.props.repeatPaymentOptions.isTransfer ? (
            <span className="c-field__option"> (optional)</span>
          ) : null}
          <div className="c-field__instructions">
            {this.props.repeatPaymentOptions.isTransfer
              ? this.props.content.referenceFieldMsgMoveMoneyTransfer
              : this.props.content.referenceFieldMsgMoveMoney}
          </div>
        </label>
        <div className="c-field__controls">
          <input
            className="c-field__input"
            ref="reference"
            disabled={isReadOnly}
            value={this.state.reference}
            type="text"
            name="reference"
            id="f1"
            aria-required="true"
            aria-invalid="false"
            readOnly={isReadOnly}
            onChange={this.onRefChange}
            onBlur={this.onRefBlur}
          />
          <div className="c-field__message" id="inputReference" role="alert">
            {this.props.repeatPaymentOptions.isTransfer ? (
              <p>{this.props.content.referenceErrorMsgMoveMoneyTransfer}</p>
            ) : (
              <p>{this.props.content.referenceErrorMsgMoveMoney}</p>
            )}
          </div>
        </div>
      </div>
    );
  }
  renderStartDate() {
    const dateInputProps = {
      id: 'dtStart',
      name: 'dtStart',
      onBlur: (e) => this.onStartDateBlur(e),
      onFocus: (e) => this.onStartDateFocus(e),
      ref: 'startDateInput',
      'aria-invalid': 'false',
    };
    return (
      <div className="c-field c-field--datepicker" ref="startDateComponent">
        <label
          className="c-field__label c-field__label--block"
          htmlFor="dtStart"
        >
          {this.props.content.startDate}
          <div className="c-field__instructions">
            {this.props.content.datePickerText}
          </div>
        </label>
        <div className="c-field__controls">
          <div className="c-field__append">
            <div className="pos-r">
              <DateTimeField
                dateTime={this.state.startDateValue}
                defaultValue={this.state.startDateValue}
                format={this.state.startDateInputFormat}
                inputFormat={this.state.startDateInputFormat}
                inputProps={dateInputProps}
                maxDate={this.state.startMaxDate}
                minDate={moment().add(1, 'days')}
                mode="date"
                onChange={this.onStartChange}
                ref="startDate"
                viewMode="days"
              />
            </div>
            {this.state.startDateText && (
              <div className="callout callout--pointer callout--pointer-left">
                <div className="callout__wrapper">
                  <p>{this.state.startDateText}</p>
                </div>
              </div>
            )}
          </div>

          <div
            className="c-field__message"
            ref="startMessage"
            id="startMsgErr"
            role="alert"
          >
            <p>{this.props.content.dateErrorMesaage}</p>
          </div>
        </div>
      </div>
    );
  }
  renderWhen() {
    const dateInputProps = {
      id: 'dtWhen',
      name: 'dtWhen',
      onBlur: (e) => this.onWhenBlur(e),
      onFocus: (e) => this.onWhenFocus(e),
      ref: 'futureDateInput',
      'aria-invalid': 'false',
    };
    return (
      <DateTimeField
        dateTime={this.state.defaultValue}
        defaultText={this.state.defaultValue}
        format={this.state.dateInputFormat}
        inputFormat={this.state.dateInputFormat}
        inputProps={dateInputProps}
        maxDate={moment().add(1, 'years')}
        minDate={moment()}
        mode="date"
        onChange={this.onWhenChange}
        ref="futureDate"
        viewMode="days"
      />
    );
  }
  render() {
    const {
      repeatPaymentOptions: { isReference, isFormVisible },
      repeatAccountValid,
    } = this.props;

    const { showAbusiveReferenceModal, showButtonLoader, showGlobalLoader } =
      this.state;

    return (
      <div>
        <Loader isOpen={showGlobalLoader} />
        <AbusiveReferenceModal
          isOpen={showAbusiveReferenceModal}
          toggleModal={() => {
            this.setState((prevState) => ({
              showAbusiveReferenceModal: !prevState.showAbusiveReferenceModal,
            }));
          }}
        />
        {isReference && this.renderReference()}
        {isFormVisible && repeatAccountValid && this.renderFormField()}
        <div className="web-ui-components">
          <NavigationButton.Primary
            labelText="Continue"
            isLoading={showButtonLoader}
            onClick={this.continueClick}
            data-test-id="button-continue"
          />
        </div>
      </div>
    );
  }
}

RepeatPayment.propTypes = {
  content: PropTypes.object,
  repeatData: PropTypes.object,
  repeatPaymentOptions: PropTypes.object,
  repeatAccountValid: PropTypes.bool,
  continueClick: PropTypes.func,
  onAmountChange: PropTypes.func,
  handleEwActions: PropTypes.func,
  selectedPayee: PropTypes.object,
  fromSelectedAccount: PropTypes.object.isRequired,
};

RepeatPayment.defaultProps = {
  content: {},
  repeatAccountValid: true,
  repeatPaymentOptions: {},
  repeatData: {},
};
export default RepeatPayment;
